<template>
  <footer>
    <div id="footer-warp">
      <div id="footCont">
        <img
          class="pc"
          src="../../assets/image/ico/Logo-W.svg"
          alt="LOGOTEXT"
        />
        <div class="footTxt" v-html="footTxt">
          <!-- <p>전자우편 : topkoreaservice@topkoreaservice.com</p> -->
        </div>
      </div>
    </div>
    <div id="footCopy">
      Copyright (c) (주)탑코리아서비스. All rights reserved.
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      isWidth: false,
      window: {
        width: 0,
        height: 0,
      },
    }
  },
  components: {},
  mounted() {},
  computed: {
    footTxt() {
      if (this.isWidth) {
        return `<p>상호명 : (주)탑코리아서비스 | 대표이사 : 박태란 | 주소 : 서울 강동구양재대로138길 14, 201호</p><p>사업자번호 : 135-81-96363 | TEL : 02-481-3900 | FAX : 02-481-0022</p><p>건물위생관리업 : 서울강동제135호 | 시설경비업 : 제4272호 | 소독업 :서울강동제109호</p>`
      } else {
        return `<p>상호명 : (주)탑코리아서비스 | 대표이사 : 박태란</p> <p>주소 : 서울 강동구양재대로138길 14, 201호</p><p>사업자번호 : 135-81-96363 | TEL : 02-481-3900 | FAX : 02-481-0022</p><p>건물위생관리업 : 서울강동제135호 | 시설경비업 : 제4272호 | 소독업 :서울강동제109호</p>`
      }
    },
  },
  methods: {},
  async created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  updated() {},
}
</script>

<style></style>
